import React, { useState } from "react";
import { db, auth } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

export default function AddAccount({ onBack }) {
  const [form, setForm] = useState({
    name: "",
    accountCode: "",
    size: "",
    currency: "$",
    phase: "Phase 1",
    maxDailyDD: "",
    maxTotalDD: "",
    currentPnL: "0",
    ddType: "static"
  });

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const saveAccount = async () => {
    if (!auth.currentUser) return alert("User not logged in");
    if (!form.accountCode || !form.name || !form.size) return alert("Please fill all required fields");

    const size = Number(form.size);
    const maxTotalDD = Number(form.maxTotalDD);
    const startingDD = (size * maxTotalDD) / 100;

    try {
      await addDoc(
        collection(db, "users", auth.currentUser.uid, "accounts"),
        {
          name: form.name,
          accountCode: form.accountCode,
          size,
          currency: form.currency,
          phase: form.phase,
          maxDailyDD: Number(form.maxDailyDD),
          maxTotalDD,
          currentPnL: Number(form.currentPnL),
          accountType: "prop",
          ddType: form.ddType,
          peakEquity: size + Number(form.currentPnL),
          trailingFloor: size - startingDD,
          createdAt: new Date()
        }
      );
      alert("Account added successfully!");
      if (onBack) onBack(); // Redirects back to overview after successful save
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h2 style={styles.title}>Add New Trading Account</h2>
        <p style={styles.subtitle}>
          Enter account details exactly as provided by your prop firm.
        </p>
      </header>

      <div style={styles.card}>
        <div style={styles.formGrid}>
          {/* Prop Firm Name */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>PROP FIRM *</label>
            <input
              style={styles.input}
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Apex, FTMO, QuantTekel"
            />
          </div>

          {/* Account ID */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>ACCOUNT ID *</label>
            <input
              style={styles.input}
              name="accountCode"
              value={form.accountCode}
              onChange={handleChange}
              placeholder="APX-9F3K / Eval-7721"
            />
          </div>

          {/* Account Size */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>ACCOUNT SIZE *</label>
            <input
              style={styles.input}
              type="number"
              name="size"
              value={form.size}
              onChange={handleChange}
              placeholder="50000"
            />
          </div>

          {/* Currency & Phase Row */}
          <div style={styles.row}>
            <div style={styles.col}>
              <label style={styles.label}>CURRENCY *</label>
              <select style={styles.select} name="currency" value={form.currency} onChange={handleChange}>
                <option value="$">USD ($)</option>
                <option value="₹">INR (₹)</option>
              </select>
            </div>
            <div style={styles.col}>
              <label style={styles.label}>ACCOUNT PHASE *</label>
              <select style={styles.select} name="phase" value={form.phase} onChange={handleChange}>
                <option>Phase 1</option>
                <option>Phase 2</option>
                <option>Funded</option>
              </select>
            </div>
          </div>

          {/* Drawdown Type */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>DRAWDOWN TYPE *</label>
            <select style={styles.select} name="ddType" value={form.ddType} onChange={handleChange}>
              <option value="static">Static Drawdown</option>
              <option value="trailing">Trailing Drawdown</option>
            </select>
          </div>

          {/* Drawdown Limits Row */}
          <div style={styles.row}>
            <div style={styles.col}>
              <label style={styles.label}>MAX DAILY DD (%) *</label>
              <input
                style={styles.input}
                type="number"
                name="maxDailyDD"
                value={form.maxDailyDD}
                onChange={handleChange}
                placeholder="5"
              />
            </div>
            <div style={styles.col}>
              <label style={styles.label}>MAX TOTAL DD (%) *</label>
              <input
                style={styles.input}
                type="number"
                name="maxTotalDD"
                value={form.maxTotalDD}
                onChange={handleChange}
                placeholder="10"
              />
            </div>
          </div>

          {/* Current PnL */}
          <div style={styles.inputGroup}>
            <label style={styles.label}>CURRENT PNL *</label>
            <input
              style={styles.input}
              type="number"
              name="currentPnL"
              value={form.currentPnL}
              onChange={handleChange}
              placeholder="0"
            />
          </div>
        </div>

        <button style={styles.button} onClick={saveAccount}>
          Save Account
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: { 
    maxWidth: "600px", 
    margin: "0 auto", 
    padding: "20px", 
    color: "#fff" 
  },
  header: { marginBottom: "24px" },
  title: { 
    fontSize: "24px", 
    fontWeight: "600", 
    color: "#fff", 
    marginBottom: "4px" 
  },
  subtitle: { fontSize: "14px", color: "#9ca3af" },
  card: {
    backgroundColor: "rgba(13, 17, 23, 0.4)",
    border: "1px solid #1e293b",
    borderRadius: "12px",
    padding: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  formGrid: { display: "flex", flexDirection: "column", gap: "18px" },
  inputGroup: { display: "flex", flexDirection: "column", gap: "8px" },
  label: { 
    fontSize: "11px", 
    fontWeight: "700", 
    color: "#4b5563", 
    letterSpacing: "0.05em" 
  },
  input: {
    background: "#0d1117",
    border: "1px solid #30363d",
    borderRadius: "8px",
    padding: "12px 16px",
    color: "#fff",
    fontSize: "14px",
    outline: "none",
  },
  select: {
    background: "#0d1117",
    border: "1px solid #30363d",
    borderRadius: "8px",
    padding: "12px 16px",
    color: "#fff",
    fontSize: "14px",
    cursor: "pointer",
    outline: "none",
  },
  row: { display: "flex", gap: "16px" },
  col: { flex: 1, display: "flex", flexDirection: "column", gap: "8px" },
  button: {
    background: "#0ea5e9",
    color: "#000",
    fontWeight: "700",
    border: "none",
    padding: "14px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "15px",
    marginTop: "10px",
    transition: "background 0.2s ease"
  }
};